import { useRef } from 'react';
import { gql } from 'graphql-tag';
import { useSubscription } from '@apollo/client';
import { debounce, scope } from '~/modules/common/debounce';
import fullTaskEntryFragment from '../graphql/fullTaskEntryFragment';

export const TASK_BEAT_ADDED_SUBSCRIPTION = gql`
  subscription TaskBeatAdded {
    taskEntryAddedForManager {
      ...FullTaskEntry
    }
  }
  ${fullTaskEntryFragment}
`;

export const TASK_BEAT_UPDATED_SUBSCRIPTION = gql`
  subscription TaskBeatAdded {
    taskEntryUpdatedForManager {
      ...FullTaskEntry
    }
  }
  ${fullTaskEntryFragment}
`;

export const useTaskBeatRefetchOnAddSubscription = ({ refetch }) => {
  const debounceScope = useRef(scope());
  const debouncedRefetch = () => debounce(debounceScope.current, refetch, 5000);

  useSubscription(TASK_BEAT_ADDED_SUBSCRIPTION, {
    onSubscriptionData: debouncedRefetch
  });
};

export const useTaskBeatRefetchOnUpdateSubscription = ({ refetch }) => {
  const debounceScope = useRef(scope());
  const debouncedRefetch = () => debounce(debounceScope.current, refetch, 5000);

  useSubscription(TASK_BEAT_UPDATED_SUBSCRIPTION, {
    onSubscriptionData: debouncedRefetch
  });
};
